import OrderMethodModal from './OrderMethodModal';
import OrderMethodToolbar from './OrderMethodToolbar';

export default {
  OrderMethodToolbar,
  OrderMethodModal,
};
